import {
  // action,
  computed
} from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import {
  FaBars,
  // FaClipboardList,
  FaTachometerAlt
  // FaTheaterMasks, FaUsers, FaUsersCog
  // tslint:disable-next-line: no-submodule-imports
} from 'react-icons/fa';
// tslint:disable-next-line: no-submodule-imports
// import { MdQuestionAnswer } from 'react-icons/md';
import {
  Menu,
  MenuItem,
  //   SubMenu,
  ProSidebar,
  SidebarContent,
  //   SidebarFooter,
  SidebarHeader,
  SubMenu
} from 'react-pro-sidebar';

import { DbKey } from '../../../../adl-gen/common/db';
import { AppClient, ApplicationRole } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { i18next } from '../../../../internationalization/i18next';
import { MenuLink } from '../../../../ui/common/page-layout/page-layout';
import { Pill } from '../../../../ui/widgets/pill/pill';
import { SelectBox, SelectOption } from '../../../../ui/widgets/select/select';

// tslint:disable-next-line: no-import-side-effect
import './sidebar.css';

// const pageStyles = require("../../../../ui/common/page-layout/page-layout.css");
const sideNavStyles = require('./side-nav.css');

// /// TODO Oversimplified, no submenus, have to hardcode Icons needs Actions, etc, but will do for now
// export interface MenuData {
//     Icon: JSX.Element;
//     text: string;
// }

export interface SideNavProps {
  /// Standard issue props
  backgroundImageUrl?: string;
  collapsed?: boolean;
  rtl?: boolean;
  toggled: boolean;

  handleToggleSidebar?(value: boolean): void;
  toggleSidebarCollapse?(): void;

  /// Data used to set up the menu
  menuLinks: MenuLink[];
  /// Submenu data - StringKeyMap
  subMenuLinks: { [label: string]: MenuLink[] };
  /// TODO look up UIConfig identity -> role and AppClient.name
  /// role = 'super' -> sidebarheader selector, otherwise client name
  role: ApplicationRole;
  appClientOptions: SelectOption[];
  onSelectClient(clientId: DbKey<AppClient>): void;
  selectedClient?: DbKey<AppClient>;
  showDash?: boolean;
}

@observer
export class SideNav extends React.Component<SideNavProps> {
  @computed
  get rotateBars() {
    return this.props.collapsed ? 'rotate(90deg)' : 'rotate(0)';
  }

  //   @action
  onSelectClient = (option: SelectOption) => {
    this.props.onSelectClient(option.value as string);
  };

  emitSubMenuLinks = (parentLabel: string) => {
    const { collapsed, subMenuLinks } = this.props;
    if (Object.keys(subMenuLinks).includes(parentLabel)) {
      return (
        <SubMenu translate={undefined}>
          {subMenuLinks[parentLabel].map(menu => (
            <MenuItem
              key={menu.label}
              icon={menu.Icon}
              active={menu.isHighlighted && !menu.isDisabled}
              onClick={menu.action}
              hidden={menu.isDisabled}
            >
              <span style={{ visibility: collapsed ? 'hidden' : 'visible' }}>{menu.label}</span>
            </MenuItem>
          ))}
        </SubMenu>
      );
    } else {
      return null;
    }
  };

  render() {
    const {
      collapsed,
      handleToggleSidebar,
      backgroundImageUrl,
      rtl,
      toggled,
      toggleSidebarCollapse,
      menuLinks,
      role,
      appClientOptions,
      selectedClient
    } = this.props;

    // const defaultValueSelector = appClientOptions.length === 1 ? appClientOptions[0] : undefined;
    const defaultValueSelector = appClientOptions.find(option => option.value === selectedClient);
    console.debug('DEBUG SideNav render: appClientOptions', appClientOptions.map(opt => opt.label).join(','));
    console.debug('DEBUG SideNav render: selectedClient, defaultValueSelector', selectedClient, defaultValueSelector);
    console.debug('DEBUG SideNav render: role', role === ApplicationRole.admin ? 'admin' : 'super');

    // /* DEBUG: */ console.table(menuLinks);
    return (
      <ProSidebar
        image={backgroundImageUrl}
        rtl={rtl}
        collapsed={collapsed}
        toggled={toggled}
        breakPoint="md"
        onToggle={handleToggleSidebar}
      >
        <SidebarHeader>
          <div onClick={toggleSidebarCollapse} className={sideNavStyles.collapseIcon}>
            <FaBars
              size={40}
              style={{
                transform: this.rotateBars,
                transition: 'all 0.3s linear'
              }}
              /// TODO i18n
              title={i18next.t('sidebar.expand-collapse', 'Expand/Collapse Sidebar')}
            />
          </div>
          <div style={{ visibility: collapsed ? 'hidden' : 'visible' }}>
            {/* TODO Action -> same as clicking on client in list */}
            <SelectBox
              xsSpan={3}
              title={role === ApplicationRole.super ? 'Select Client' : 'Site'}
              options={appClientOptions}
              defaultValue={defaultValueSelector}
              isDisabled={role === ApplicationRole.admin}
              onChange={this.onSelectClient}
            />
          </div>
        </SidebarHeader>

        <SidebarContent>
          <Menu iconShape="round">
            {this.props.showDash && (
              <MenuItem
                icon={<FaTachometerAlt size={20} />}
                active
                /// TODO Pill
                suffix={<Pill kind="filled">{i18next.t('sidebar.new', 'new')}</Pill>}
                // suffix={<span className="badge red">{i18next.t('sidebar.new','new')}</span>}
              >
                {i18next.t('sidebar.dashboard', 'Dashboard')}
              </MenuItem>
            )}
            {menuLinks.map(menu => {
              return (
                // <React.Fragment>
                <MenuItem
                  key={menu.label}
                  icon={menu.Icon}
                  active={menu.isHighlighted && !menu.isDisabled}
                  onClick={menu.action}
                  hidden={menu.isDisabled}
                >
                  <span style={{ visibility: collapsed ? 'hidden' : 'visible' }}>{menu.label}</span>
                </MenuItem>
                // {/* {this.emitSubMenuLinks(menu.label)} */}
                // </React.Fragment>
              );
            })}
          </Menu>
          {/* <Menu iconShape="circle">
                        <SubMenu
                            suffix={<Pill kind="bordered">3</Pill>}
                            // suffix={<span className="badge yellow">3</span>}
                            title={i18next.t('sidebar.with-suffix','withSuffix')}
                            icon={<FaRegLaughWink />}
                            translate={undefined}
                        >
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 1</MenuItem>
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 2</MenuItem>
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 3</MenuItem>
                        </SubMenu>
                        <SubMenu
                            prefix={<Pill kind="bordered">3</Pill>}
                            // prefix={<span className="badge gray">3</span>}
                            title={i18next.t('sidebar.with-prefix','withPrefix' )}
                            icon={<FaHeart />}
                            translate={undefined}
                        >
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 1</MenuItem>
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 2</MenuItem>
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 3</MenuItem>
                        </SubMenu>
                        <SubMenu title={i18next.t('sidebar.multi-level','multiLevel')} icon={<FaList />} translate={undefined}>
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 1 </MenuItem>
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 2 </MenuItem>
                            <SubMenu title={`${i18next.t('sidebar.sub-menu', 'submenu')} 3`} translate={undefined}>
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 3.1 </MenuItem>
                            <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 3.2 </MenuItem>
                            <SubMenu title={`${i18next.t('sidebar.sub-menu', 'submenu')} 3.3`} translate={undefined}>
                                <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 3.3.1 </MenuItem>
                                <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 3.3.2 </MenuItem>
                                <MenuItem>{i18next.t('sidebar.sub-menu', 'submenu')} 3.3.3 </MenuItem>
                            </SubMenu>
                            </SubMenu>
                        </SubMenu>
                    </Menu> */}
        </SidebarContent>

        {/* <SidebarFooter style={{ textAlign: 'center', minHeight: '56px' }}>
                    <footer className={pageStyles.footer}></footer>
                    {/* <div
                        className="sidebar-btn-wrapper"
                        style={{
                            padding: '20px 24px',
                    }}
                    >
                    <a
                        href="https://github.com/azouaoui-med/react-pro-sidebar"
                        target="_blank"
                        className="sidebar-btn"
                        rel="noopener noreferrer"
                    >
                        <FaGithub />
                        <span style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        {i18next.t('sidebar.view-source', 'viewSource')}
                        </span>
                    </a>
                    </div> * /}
                </SidebarFooter> */}
      </ProSidebar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/sidebar/side-nav.tsx